import { ModalStyles } from './modalStyles';

// Modal backdrop ************************************
export function ModalBackdrop() {
  return <div className={ModalStyles.backdrop} />;
}
